import { Injectable } from '@angular/core';
import { IPageVisibility } from '../../models/page.interface';
import { MicrophoneSettingsSection } from './microphone-section/microphone-section';
import { AudioSmartSection } from './audio-smart-section/audio-smart-section';

@Injectable({
	providedIn: 'root',
})
export class AudioPage implements IPageVisibility {
	constructor(
		private audioSmartSection: AudioSmartSection,
		private microphoneSection: MicrophoneSettingsSection
	) {}

	private sections = [this.microphoneSection, this.audioSmartSection];

	public async isVisible(): Promise<boolean> {
		const sectionsVisibilities = await Promise.all(
			this.sections.map((section) => section.isVisible())
		);
		const isSomeSectionVisible = sectionsVisibilities.some((visible) => visible);

		return isSomeSectionVisible;
	}
}
